import { render } from "./MyResults.vue?vue&type=template&id=10a67db6&scoped=true"
import script from "./MyResults.vue?vue&type=script&lang=js"
export * from "./MyResults.vue?vue&type=script&lang=js"

import "./MyResults.vue?vue&type=style&index=0&id=10a67db6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a67db6"]])

export default __exports__